
import uiMixin from '@/mixins/uiMixin';

export default {
  mixins: [uiMixin],
  name: 'FAQSection',
  props: {
    sectionTitle: {
      required: false,
      type: String,
      default: null,
    },
    faq: {
      required: true,
      type: Array,
    },
    isLoaded: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
};
